import * as Config from "@/data/config.json";
import * as Dictionary from "@/data/dictionary.json";
import {
  IConfig,
  IVotematch,
  IStatement,
  IParty,
  IShootoutStatement,
  IDictionary,
} from "./interfaces";

// # use this if you want to test unencrypted data instead of the
// # crypted version below. see the README. never commit !
// import * as defaultData from '@/data/data.json';
// const Data = {
//	default: {
//		votematch : (defaultData as any).votematch ?? '', // this isnt there ?
//		parties: defaultData.parties as IParty[],
//		statements: defaultData.statements as IStatement[],
//		shootoutStatements: defaultData.shootoutStatements as IShootoutStatement[]
//	}
//};

import CryptedData from "@/data/crypted";
const decrypt = decodeURI(atob(CryptedData));
const Data = { default: JSON.parse(decrypt) } as {
  default: {
    votematch: IVotematch;
    parties: IParty[];
    statements: IStatement[];
    shootoutStatements: IShootoutStatement[];
  };
};

export const config = (Config as any).default as IConfig;
export const dictionary = (Dictionary as any).default as IDictionary;
export const votematch = Data.default.votematch;
export const parties = Data.default.parties;
export const rawStatements = Data.default.statements;
export const rawShootoutStatements = Data.default.shootoutStatements;
